import { defineStore } from "pinia";
import axios from "axios";
import { computed, ref, onMounted, watch } from "vue";
import { useRequestsStore } from "@/stores/storeRequests";
import { API_URL } from "@/utils/constans";

export const useQuizEmojiStore = defineStore("quizEmoji", () => {
	const storeRequests = useRequestsStore();
	const tokenGameEmoji = ref(localStorage.getItem("tokenGameEmoji"));

	const setToken = (newToken) => {
		tokenGameEmoji.value = newToken;
		localStorage.setItem("tokenGameEmoji", newToken);
	};

	const removeToken = () => {
		tokenGameEmoji.value = null;
		localStorage.removeItem("tokenGameEmoji");
	};

	const isLoaderQuiz = ref(false);
	const quizData = ref({});
	const finishData = ref({});
	const isShowWelcomScreen = ref(true);
	const isShowGame = ref(false);
	const isShowEndGame = ref(false);
	const isShowResultGame = ref(false);

	const totalQuestion = computed(() => quizData.value?.total);
	const currentQuestion = computed(() => quizData.value?.counter);
	const answers = computed(() => quizData.value?.answers);
	const emojis = computed(() => quizData.value?.emojis);
	const text = computed(() => {
		const textValue = quizData.value?.text || '';
		return Array.from(textValue);
	});
	const final = computed(() => quizData.value?.final);
	const additionalData = computed(() => quizData.value?.additional_data);
	const additionalDataImage = computed(() => quizData.value?.additional_data.image || "");
	const statusFinishGame = computed(() => finishData.value?.status);

	const timerActive = ref(false);
	const isPaused = ref(false);
	const remainingTime = ref({
		minutes: "3",
		secundes: "00",
	});

	let intervalId;
	const timer = () => {
		let totalSeconds = 60 * 3;
		timerActive.value = true;
		isPaused.value = false;

		intervalId = setInterval(() => {

			if (isPaused.value) return;

			const minutes = Math.floor(totalSeconds / 60);
			const seconds = totalSeconds % 60;

			remainingTime.value.minutes = String(minutes).padStart(2, "0");
			remainingTime.value.secundes = String(seconds).padStart(2, "0");

			if (totalSeconds <= 0) {
				endGame();
			} else {
				totalSeconds--;
			}
		}, 1000);
	};

	const pauseTimer = () => {
		isPaused.value = true;
	};
	
	const resumeTimer = () => {
		isPaused.value = false;
	};
	
	const stopTimer = () => {
		if (intervalId.value) {
			clearInterval(intervalId.value);
			intervalId.value = null;
		}
		timerActive.value = false;
	};
	const resetTimer = () => {
		clearInterval(intervalId);
	};

	watch(() => statusFinishGame.value, (newSatatus) => {
		if (newSatatus === 'unsuccessful') {
			isShowResultGame.value = false;
			removeToken();
			quizData.value = {};
		}

		if(newSatatus === 'successful_unauthorized' || newSatatus === 'successful_authorized') {
			isShowResultGame.value = true;
		}

		if(newSatatus === 'successful_unauthorized') { //"Неавторизованный пользователь ответил на все вопросы"			
			setToken(quizData.value.session);
		}
	});

	const endGame = async () => {
		clearInterval(intervalId);
		isShowGame.value = false;
		isShowEndGame.value = true;
		await finishGame();
	};

	const startGame = async () => {
		isLoaderQuiz.value = true;
		isShowWelcomScreen.value = false;
		isShowEndGame.value = false;
		isShowGame.value = true;
		timer();
		question();
	};
	const restartGame = async () => {	
		clearInterval(intervalId);	
		isShowEndGame.value = false;
		isShowGame.value = false;	
		isShowWelcomScreen.value = true;
		quizData.value = {};
		finishData.value = {};
	};

	const question = async () => {
		isLoaderQuiz.value = true;
		window.scrollTo({
			top: 0,
			behavior: "smooth" 
		});
		try {
			storeRequests.setAuthHeader();
			if (final.value) {				
				endGame();
				return;
			}
			const { data } = await axios.get(`${API_URL}/api/quiz_test/question?uuid=${quizData.value.session}`);
			quizData.value = data;
			
		} catch (error) {
			console.log("startGame error:", error);
			if(error.response.status === 400) {
				// removeToken()
				// setToken(quizData.value.session);
			}
		} finally {
			isLoaderQuiz.value = false;
		}
	};

	const answerToQuestion = async (answerId) => {
		isLoaderQuiz.value = true;
		pauseTimer();
		try {
			const parameters = {
				answer: answerId,
				question: quizData.value.id,
			};
			storeRequests.setAuthHeader();
			const { data } = await axios.post(`${API_URL}/api/quiz_test/answer?uuid=${quizData.value.session}`, parameters);
			quizData.value = data;
		} catch (error) {
			console.log("answerToQuestion error:", error);
		} finally {
			isLoaderQuiz.value = false;
			resumeTimer();
		}
	};

	const finishGame = async () => {
		try {
			storeRequests.setAuthHeader();
			const { data } = await axios.get(`${API_URL}/api/quiz_test/final_message?uuid=${quizData.value.session}`);
			finishData.value = data;
		} catch (error) {
			console.log("finishGame:", error);
		}
	};

	

	return {
		startGame,
		question,
		answerToQuestion,
		stopTimer,
		restartGame,
		resetTimer,

		isLoaderQuiz,
		quizData,
		isShowWelcomScreen,
		isShowGame,
		isShowEndGame,
		isShowResultGame,
		remainingTime,
		finishData,

		totalQuestion,
		currentQuestion,
		answers,
		emojis,
		text,
		final,
		additionalData,
		additionalDataImage,
	};
});
